import { createSelector } from '@reduxjs/toolkit'
import { State } from 'store'

export const getUiState = (state: State) => state.ui

export const getPageNumber = createSelector(getUiState, ui => ui.pageNumber)
